<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="38"
    :style-class-contain="styleClassContain"
    :class-name="`tw-z-[1071]`"
  >
    <ModalHeader
      :is-header="`no__header`"
      style="z-index: 10"
      title=""
      @close="handleCloseModal"
    />
    <div class="tw-pt-0 tw-p-10 tw-flex tw-flex-col">
      <div class="tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]">
        <div
          class="tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px]"
        >
          {{ title }}
        </div>
      </div>
      <div
        class="tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-text-[#231F20]"
      >
        <div>
          {{ description }}
          <span class="tw-font-semibold">
            {{
              getComponentUiText(
                "app-settings-team-members-profile-modal-delete-action-helper-b-1",
              )
            }}
          </span>
        </div>
      </div>
      <div class="tw-pt-10">
        <WizardInputQuestion
          v-model="endDate"
          :type="INPUT_TYPE.Date"
          :title="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-services-end-date-question-1',
            )
          "
          :required="true"
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-start-date-title',
            )
          "
          :valid-state="validDate"
          :valid-message="
            getComponentUiText('app-setting-org-detail-required-fields-1')
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          col-class="col-sm-8"
        />
      </div>
      <div class="tw-flex tw-justify-end tw-mt-10">
        <b-button
          style="line-height: 90%; border: 2px solid #387dff; height: 39px"
          variant="primary"
          class="tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
          type="submit"
          :disabled="loadingDelete"
          @click="handleCloseModal"
        >
          {{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
            )
          }}
        </b-button>
        <b-button
          style="line-height: 90%; border: 2px solid #387dff; height: 39px"
          variant="primary"
          class="tw-w-fit tw-mr-[15px] tw-shadow-none tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
          type="submit"
          :disabled="loadingDelete"
          @click="updateData"
        >
          {{
            getComponentUiText(
              "app-wizards-setup-wizard-modal-delete-button-title-update-1",
            )
          }}
        </b-button>
        <button
          :class="`${
            loadingDelete
              ? 'tw-text-[transparent] tw-w-[84px] tw-flex tw-justify-center tw-items-center'
              : 'tw-text-white'
          } tw-bg-[#F7553C] hover:!tw-bg-[#c82333] tw-border-[#F7553C] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium`"
          @click="deleteData"
        >
          <span v-if="!loadingDelete">{{
            getComponentUiText(
              "app-settings-domain-verify-modal-delete-button-1",
            )
          }}</span>
          <div v-if="loadingDelete" class="tw-h-[39px] tw-w-[39px]">
            <!-- eslint-disable vue/no-unused-refs -->
            <LottieAnimation
              ref="anim"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
          </div>
        </button>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import ModalHeader from "../../components/common/modalHeader.vue";
import { getComponentUiText } from "../../utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "../../components/common/modalComponent.vue";
import { INPUT_TYPE } from "@/utils/constants";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import store from "@/store";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  endDate: {
    type: String,
    required: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
  idItem: {
    type: Number,
    required: false,
    default: null,
  },
  page: {
    type: String,
    required: true,
  },
});

let showRef = ref(props.show);
const endDate = ref(props.endDate);
const validDate: any = ref(null);
const loadingDelete = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

watch(
  () => endDate.value,
  () => {
    if (endDate.value) {
      validDate.value = null;
    }
  },
);

const emit = defineEmits([
  "update:show",
  "update:data",
  "delete:data",
  "delete:data:error",
]);
const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const updateData = () => {
  if (!endDate.value) {
    validDate.value = false;
    return;
  }
  showRef.value = false;
  emit("update:data", endDate.value);
  emit("update:show", showRef.value);
};
const deleteData = async () => {
  if (props.idItem) {
    loadingDelete.value = true;
    try {
      const res = await store.dispatch("SetupWizard/handleDeleteItem", {
        page: props.page,
        id: props.idItem,
      });
      emit("delete:data", { data: res });
      showRef.value = false;
      emit("update:show", showRef.value);
    } catch (error) {
      emit("delete:data:error");
      showErrorAPI(error, Org.postDomainSetup);
    } finally {
      loadingDelete.value = false;
    }
  } else {
    showRef.value = false;
    emit("update:show", showRef.value);
    emit("delete:data", { data: null });
  }
};

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  overflow: "unset",
};
</script>

<style lang="scss">
.assessment-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: red;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }
}

@media (max-width: 768px) {
  .assessment-modal {
    .modal-assessment,
    .modal-header {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
}
</style>
